export const ORGANIZATION_SIGN_UP_LINK = process.env.REACT_APP_ORGANIZATION_SIGN_UP_LINK;
